import './HomePageKycDialog.less';

import React from 'react';
import { nuiCtx } from '../../../common/initialization';
import { createDialog, DialogProps, openDialog } from '../../dialogs/dialogs';
import i18n from '../../../common/i18n';
import { Button } from '../../button/Button';
import KycFormDialog from '../../registration-completion/view/dialog/KycFormDialog';
import KycDocsIcon from 'nike-ui/src/icons/svg/kyc-docs-icon-sv.svg';
import KycFormExpandedHeader from '../../registration-completion/view/step_set_kyc_form/KycFormExpandedHeader';

const HomepageKycDialog = createDialog({
    name: 'homepage-kyc-dialog',
    component: ({ close, postfix }: { postfix?: string } & DialogProps) => {
        const { NuiDialog } = nuiCtx.components;

        const handleClick = () => {
            nuiCtx.closeAllDialogs();
            openDialog(KycFormDialog);
        };

        return (
            <NuiDialog mobileMode="DOCKED" name="homepage-kyc-dialog" className="modal-xs" onClose={close}>
                <div className="flex flex-col text-center">
                    <div className="mt-50 mb-20">
                        <KycDocsIcon />
                    </div>
                    <KycFormExpandedHeader postfix={postfix} />
                    <div>
                        <Button
                            className="mb-30 full-width mt-50"
                            large
                            primary
                            onClick={handleClick}
                            label={i18n('nui.common.fill.In.button')}
                        />
                    </div>
                </div>
            </NuiDialog>
        );
    }
});

export default HomepageKycDialog;
